import { GenericAbortSignal } from 'axios'
import { API_APPLICANT_URL } from '../constants/base-urls'
import type { IDataTableCandidateApplicant, IPaginationParam, IPaginationResponse, IVacancy } from '../types'
import { createAxiosInstance } from '../utils'

const axios = createAxiosInstance({
  baseURL: API_APPLICANT_URL,
  withAuth: true,
})

type FetchCandidateParams = {
  education?: string
  position?: string
  province?: string
  vacancyId?: string
  isVideo?: string
} & IPaginationParam

export const fetchBlacklist = (params?: FetchCandidateParams, signal?: GenericAbortSignal) => {
  return axios
    .get<{ data: IPaginationResponse<IDataTableCandidateApplicant> }>(`/applicant/blacklist`, { params, signal })
    .then((response) => response.data.data)
}

export const unblacklist = (id: string) => {
  return axios.patch(`/applicant/blacklist/${id}`).then((response) => response.data.data)
}

export const createBlacklist = (payload: Record<string, any>) => {
  return axios.post<{ data: IDataTableCandidateApplicant }>(`/applicant/blacklist`, payload).then((response) => response.data.data)
}

export const apply = (payload: Record<string, any>) => {
  return axios.post<{ data: IDataTableCandidateApplicant }>(`/applicant/apply`, payload).then((response) => response.data.data)
}

export const offer = (payload: Record<string, any>) => {
  return axios.post<{ data: IDataTableCandidateApplicant }>(`/applicant/offer`, payload).then((response) => response.data.data)
}

export const rejectOffer = (payload: Record<string, any>) => {
  return axios.patch<{ data: IDataTableCandidateApplicant }>(`/applicant/reject-offer`, payload).then((response) => response.data.data)
}

export const fetchOffer = (params?: FetchCandidateParams, signal?: GenericAbortSignal) => {
  return axios
    .get<{ data: IPaginationResponse<IDataTableCandidateApplicant> }>(`/applicant/offer`, { params, signal })
    .then((response) => response.data.data)
}

export const fetchCandidateManagement = (params?: FetchCandidateParams, signal?: GenericAbortSignal) => {
  return axios
    .get<{ data: IPaginationResponse<IDataTableCandidateApplicant> }>(`/candidate-management`, { params, signal })
    .then((response) => response.data.data)
}

export const createShortlist = (payload: Record<string, any>) => {
  return axios.post<{ data: IDataTableCandidateApplicant }>(`/applicant/shortlist`, payload).then((response) => response.data.data)
}

export const deleteShortlist = (payload: Record<string, any>) => {
  return axios.delete('/applicant/shortlist', { data: payload }).then((response) => response.data.data)
}

export const fetchShortlist = (params?: FetchCandidateParams, signal?: GenericAbortSignal) => {
  return axios
    .get<{ data: IPaginationResponse<IDataTableCandidateApplicant> }>(`/applicant/shortlist`, { params, signal })
    .then((response) => response.data.data)
}

export const fetchWithdraw = (params?: FetchCandidateParams, signal?: GenericAbortSignal) => {
  return axios
    .get(`/applicant/withdraw`, {
      params,
      signal,
    })
    .then((response) => response.data.data)
}

export const withdraw = (payload: Record<string, any>) => {
  return axios.patch<{ data: IDataTableCandidateApplicant }>(`/applicant/withdraw`, payload).then((response) => response.data.data)
}

export const reject = (payload: Record<string, any>) => {
  return axios.patch<{ data: IDataTableCandidateApplicant }>(`/applicant/reject-apply`, payload).then((response) => response.data.data)
}

export const fetchReject = (params?: FetchCandidateParams, signal?: GenericAbortSignal) => {
  return axios
    .get<{ data: IPaginationResponse<IDataTableCandidateApplicant> }>(`/applicant/reject-apply`, { params, signal })
    .then((response) => response.data.data)
}

export const moveToAnotherVacancy = (payload: Record<string, any>) => {
  return axios
    .post<{ data: { warning: { type: string; message: string } | null } }>(`/applicant/move-to-another-vacancy`, payload)
    .then((response) => response.data.data)
}

export const applyVacancy = (payload: Record<string, any>) => {
  return axios
    .post<{ data: { warning: { type: string; message: string } | null } }>(`/basic/apply`, payload)
    .then((response) => response.data.data)
}

export const fetchVacanciesCandidate = (id: string) => {
  return axios.get<{ data: IPaginationResponse<IVacancy> }>(`/applicant/vacancy/${id}`).then((response) => response.data.data)
}

export const fetchVacanciesCandidateXplore = (id: string) => {
  return axios.get<{ data: IPaginationResponse<IVacancy> }>(`/vacancy/offer/${id}`).then((response) => response.data.data)
}

export const sendReminder = (applicanId: string) => {
  return axios.patch(`applicant/offer/remind?applicantId=${applicanId}`)
}
